const jobFieldLabels = {
  _id: 'ID',
  version: 'Version',
  __v: 'Schema Version',
  id: 'Job ID',
  prodCreatedByUser: 'Production Creator',
  createdBy: 'Created By',
  createBy: 'Created By',
  isNew: 'Is New',
  createEpoch: 'Created Timestamp',
  beingModified: 'Being Modified',
  assignees: 'Assignees',
  type: 'Job Type',
  notifiedExternal: 'Notified External Parties',
  oldOwners: 'Previous Owners',
  reports: 'Reports',
  taskProgress: 'Task Progress',
  userLocation: 'User Location',
  salesForceInfoText: 'SalesForce Info',
  summaryText: 'Executive Summary',
  revisionDescription: 'Revision Description',
  csmField: 'CSM',
  repairEngineer: 'Repair Engineer',
  workStatusCode: 'Work Status Code',
  tagName: 'Tag Name',
  salesInfoText: 'Sales Order',
  reportNote: 'Report Note',
  serialInfoText: 'Serial Info',
  projectNumber: 'Project Number',
  modifyStartTime: 'Modify Start Time',
  jobCompleteDate: 'Completion Date',
  jobCompletedByUser: 'Completed By',
  isProduct: 'Is Product',
  isEditable: 'Editable',
  workOrderNumber: 'Work Order Number',
  duplicatedBy: 'Duplicated By',
  classList: 'Classifications',
  copy: 'Copy ID',
  customer: 'Customer',
  cssText: 'CSS Text',
  copyNumber: 'Copy Number',
  documentNumber: 'Document Number',
  approvalStatus: 'Approval Status',
  companyInfoText: 'Company',
  workOrderName: 'Work Order Name',
  name: 'Job Name',
  modifier: 'Modified By',
  executingSite: 'Executing Site',
  sites: 'Sites',
  childConfig: 'Child Configurations',
  revision: 'Revision',
  newTemplateRevisionCreatedBy: 'New Template Revision By',
  search_title: 'Search Title',
  favoriteCount: 'Favorite Count',
  sapReference: 'SAP Reference',
  search_workOrderName: 'Search Work Order',
  search_model: 'Search Model',
  search_frameType: 'Search Frame Type',
  search_brand: 'Search Brand',
  search_workOrderNameStr: 'Search Work Order Name',
  search_modelStr: 'Search Model String',
  search_frameTypeStr: 'Search Frame Type String',
  search_brandStr: 'Search Brand String',
  search_userEnteredPartNumber: 'Search Part Number',
  search_createdUserLocationName: 'Search User Location',
  search_createdUserFullname: 'Search Creator Name',
  search_customerInfoText: 'Search Customer Info',
  search_projectInfoText: 'Search Project Info',
  search_documentNumber: 'Search Document Number',
  search_serialNumber: 'Search Serial Number',
  search_revision: 'Search Revision',
  search_sapReference: 'Search SAP Reference',
  search_salesForceNumber: 'Search SalesForce Number',
  search_workOrderNumber: 'Search Work Order Number',
  search_executingSite: 'Search Executing Site',
  search_csmUser: 'Search User',
  deletedBy: 'Deleted By',
  deletedAt: 'Deleted At',
  deleted: 'Deleted',
  uploadFile: 'Uploaded Files',
  date: 'Date',
  externalClientCreator: 'External Client Creator',
  thumbnailUrl: 'Thumbnail URL',
  assemblyOverviewUrl: 'Reference Image',
  brand: 'Brand',
  completenessPercentage: 'Completeness %',
  customerInfoText: 'Customer',
  frameType: 'Frame Type',
  model: 'Model',
  originalOEMNumber: 'Original OEM Number',
  title: 'Title',
  userEnteredPartNumber: 'Entered Part Number',
  jobCompleted: 'Job Completed',
  status: 'Status',
  jobPhases: 'Job Phases',
  projectInfoText: 'Project Number',
  serialNumber: 'Unit Serial',
  salesForceNumber: 'Sales Force Opportunity Number',
  taskCount: 'Task Count',
  location: 'Location',
  partNumber: 'Part Number',
  repairAssessment: 'Repair Assessment',
  deviationReport: 'Deviation Report',
  excludedItems: 'Excluded Items',
  checkedOut: 'Checked Out By',
  checkedOutAt: 'Checked Out At',
  wsConnections: 'WebSocket Connections',
  updateEpoch: 'Last Updated Timestamp',
  updateBy: 'Last Updated By',
};

const bubbleFieldLabels = {
  _id: 'ID',
  version: 'Version',
  taskId: 'Task ID',
  type: 'Type',
  lengthType: 'Length Type',
  label: 'Label',
  values: 'Values',
  expectedValue: 'Expected Value',
  inspectorComment: 'Inspector Comment',
  tolerance: 'Tolerance',
  tolerance1: 'Tolerance 1',
  tolerance2: 'Tolerance 2',
  unit: 'Unit',
  lastModifiedBy: 'Last Modified By',
  lastUpdatedBy: 'Last Updated By',
  lastModifiedAt: 'Last Modified At',
  measurementName: 'Measurement Name',
  visualName: 'Visual Name',
  runoutName: 'Runout Name',
  value: 'Measured Value',
  condition: 'Condition',
  measurements: 'Measurements',
  measurementCount: 'Measurement Count',
  multipleMeasurements: 'Multiple Measurements',
  point: 'Position',
  startPoint: 'Start Point',
  firstPoint: 'First Point',
  secondPoint: 'Second Point',
  thirdPoint: 'Third Point',
  fourthPoint: 'Fourth Point',
  toleranceType: 'Tolerance Type',
  positiveTolerance: 'Positive Tolerance',
  negativeTolerance: 'Negative Tolerance',
  number: 'Label',
  images: 'Images',
  text: 'Text',
  ratRowID: 'Row ID',
  textSize: 'Size',
  orientation: 'Orientation',
  directionalUnit: 'Directional Unit',
  decimalPlaces: 'Decimal Places',
  isoName: 'ISO Name',
  isoGrade: 'ISO Grade',
  description: 'Description',
  descriptionDropdown: 'Dropdown Description',
  hasDescription: 'Has Description',
  inTable: 'Display In Table',
  tableMeasurements: 'Table Measurements',
};
const taskFieldLabels = {
  taskName: 'Name',
  folderTitle: 'Name',
  taskComment: 'Task Comment',
};

const questionFieldLabels = {
  _id: 'ID',
  version: 'Version',
  taskId: 'Task ID',
  type: 'Type',
  isPictureMandatory: 'Picture Mandatory',
  question: 'Question',
  lastModifiedBy: 'Last Modified By',
  lastModifiedAt: 'Last Modified At',
  lastUpdatedBy: 'Last Updated By',
  label: 'Label',
  findingsByInspector: 'Findings by Inspector',
  yesOrNo: 'Yes or No',
  multipleChoices: 'Multiple Choices',
  multipleChoicesValues: 'Multiple Choice Values',
  inputValue: 'Input Value',
  dimensions: 'Dimensions',
  tableColumn: 'Table Column',
  tableRow: 'Table Row',
  tableImg: 'Table Image',
  tableData: 'Table Data',
  checked: 'Checked',
  image: 'Image',
  imageReference: 'Image Reference',
};

const ratMeasurementsLabel = {
  itemNumber: 'Item Number',
  repair: 'Repair',
  reuse: 'Reuse',
  originalPartNumber: 'Original Part Number',
  originalQuantity: 'Original Quantity',
  originalAssembly: 'Original Assembly',
  replace: 'Replace',
  lockedAt: 'Locked At',
  dim: 'Dimensions',
  changeLog: 'Change Log',
  qualityControlOverride: 'Quality Control Override',
  repairScope: 'Repair Scope',
  originalItemNumber: 'Original Item Number',
  partName: 'Part Name',
  lockedBy: 'Locked By',
  conflictDetails: 'Conflict Details',
  assembly: 'Assembly',
  missing: 'Missing',
  reviewed: 'Reviewed',
  visual: 'Visual Reference',
  clientReject: 'Client Reject',
  id: 'ID',
  summary: 'Summary',
  lastUpdatedBy: 'Last Updated By',
  images: 'Images',
  quantity: 'Quantity',
  level: 'Level',
  received: 'Received',
  originalPartName: 'Original Part Name',
  version: 'Version',
  estimatedLabor: 'Estimated Labor',
  isMinor: 'Is Minor',
  bubbleId: 'Bubble ID',
  partNumber: 'Part Number',
  ndt: 'NDT',
};

// eslint-disable-next-line import/prefer-default-export
export const fieldLabels = {
  ...bubbleFieldLabels,
  ...questionFieldLabels,
  ...ratMeasurementsLabel,
  ...jobFieldLabels,
  ...taskFieldLabels,
  version: 'Version',
  point: 'Position',
};
